export default __webpack_public_path__ + "static/media/individualFiling.cf2b18c1.svg";